module.exports = __webpack_public_path__ + "img/card2.2923a96f.png";